import { module } from 'angular'
import { WorkflowService } from './workflow.service'
import { WorkflowsActionHandlerComponent } from './WorkflowsActionHandler'

module('webregister.services').service('workflowService', WorkflowService)

module('webregister.components').component(
  'workflowsActionHandler',
  WorkflowsActionHandlerComponent
)
